<template>
  <div id="overlay">
    <div class="center w-6/12">
      <div
        class="content border border-1 border-solid bg-white p-2 flex flex-col"
      >
        <div class="text-gray-800 text-3xl my-auto">
          {{ "Upload Images" }}
        </div>
        <!-- Upload Files -->
        <div class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <toggle-button
              @change="onChangeEventHandler"
              :labels="{ checked: 'file', unchecked: 'folder' }"
              :width="60"
              :height="30"
              :margin="4"
              :color="{ checked: '#E40046', unchecked: '#E40046' }"
              switch-color="#ffff"
            />
            <input
              v-if="this.uploadType == 'file'"
              multiple="multiple"
              class="effect-16 w-full"
              type="file"
              placeholder="Files*"
              @change="selectFiles($event)"
              directory
              accept=".png,.jpeg,.jpg"
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <!-- Directory || Folder -->
        <div class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <input
              v-if="this.uploadType == 'folder'"
              multiple
              class="effect-16 w-full"
              type="file"
              placeholder="Files*"
              @change="selectFiles($event)"
              directory
              webkitDirectory
            />
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <div v-if="batches" class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <select class="effect-16 w-full" v-model="imageType">
              <option :value="null" disabled selected hidden>
                {{ "Image(s) Type*" }}
              </option>
              <option
                v-for="(imageType, index) in imageTypes"
                :key="index"
                :value="imageType.id"
              >
                {{ imageType.name }}
              </option>
            </select>
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <div v-if="batches" class="text-gray-800 text-3xl my-auto">
          <div class="col-3 input-effect w-full">
            <select class="effect-16 w-full" v-model="batchId" required>
              <option :value="null" selected hidden disabled>
                Batch Name*
              </option>
              <option
                v-for="(batch, index) in batches"
                :key="index"
                :value="batch.id"
              >
                {{ batch.name }}
              </option>
            </select>
            <span class="focus-border w-full"></span>
          </div>
        </div>
        <div class="w-full flex justify-end p-3">
          <div class="flex flex-row" style="width: 300px">
            <button
              v-if="batches"
              :disabled="
                !imageType ||
                !files ||
                !batchId ||
                imageType.length == 0 ||
                files.length == 0
              "
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="multipartUpload()"
            >
              {{ "Upload" }}
            </button>
            <!-- Upload button if we have batchId as props -->
            <button
              v-else
              :disabled="!files || files.length == 0"
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="multipartUpload()"
            >
              {{ "Upload" }}
            </button>
            <button
              class="m-1 w-full h-12 rounded-sm bg-button label text-whiteText text-xs"
              @click="$emit('close')"
            >
              Close
            </button>
          </div>
        </div>

        <vue-good-table
          v-if="filesArray.length"
          :columns="columns"
          :rows="filesArray"
          :search-options="{
            enabled: true,
          }"
          :pagination-options="{
            mode: 'pages',
            perPage: 10,
            perPageDropdown: [10, 20, 30, 40, 50],
            enabled: true,
          }"
          compactMode
        >
          <template slot="table-row" slot-scope="props">
            <!-- Actions for projects page -->
            <span v-if="props.column.field == 'progress'" class="">
              <div class="relative pt-1">
                <div
                  class="overflow-hidden h-2 mb-4 text-xs flex rounded bg-red-200"
                >
                  <div
                    :id="props.row.name"
                    :style="props.row.progress"
                    class="shadow-none flex flex-col text-center whitespace-nowrap text-white justify-center bg-woo"
                  ></div>
                </div>
              </div>
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Http, { OCR_ENDPOINTS } from "../request";
import { VueGoodTable } from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import { Semaphore } from "await-semaphore";
import { ToggleButton } from "vue-js-toggle-button";
Vue.component("ToggleButton", ToggleButton);
var semaphore = new Semaphore(10);

export default {
  data() {
    return {
      batch: this.row,
      contentProgress: 0,
      uploadType: "folder",
      imageType: null,
      batchId: this.row.id || null,
      files: [],
      counter: 0,
      filesArray: [],
      columns: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Size",
          field: "size",
          type: "number",
        },
        {
          label: "Type",
          field: "type",
        },

        {
          label: "Status",
          field: "status",
        },
        {
          label: "Progress",
          field: "progress",
        },
      ],
    };
  },

  components: { VueGoodTable },

  props: {
    batches: Array,
    row: Object,
    imageTypes: Array,
  },
  created() {},
  methods: {
    // uploadImages(image) {
    //   const myUploadProgress = (myFileName) => (progress) => {
    //     let percentage = Math.floor((progress.loaded * 100) / progress.total);
    //     const searchObject = this.filesArray.find(
    //       (image) => image.name == myFileName
    //     );

    //     searchObject.progress = "width:" + percentage + "%";
    //   };

    //   console.log("image");
    //   let formData = new FormData();
    //   formData.append("file", image);
    //   if (this.imageType) {
    //     formData.append("type", this.imageType);
    //   }
    //   formData.append("batchId", this.batchId);
    //   var config = {
    //     onUploadProgress: myUploadProgress(image.name),
    //   };

    //   Http()
    //     .post(OCR_ENDPOINTS.images, formData, config)
    //     .then((response) => {
    //       let success = response?.data?.images;
    //       let fail = response?.data?.failedImages;

    //       if (success.length) {
    //         success.forEach((arrayItem) => {
    //           const searchObject = this.filesArray.find(
    //             (search) => search.name == arrayItem.name
    //           );
    //           searchObject.status = "Done";
    //         });
    //       }
    //       if (fail?.length) {
    //         fail.forEach((arrayItem) => {
    //           console.log(arrayItem);
    //           const searchObject = this.filesArray.find(
    //             (image) => image.name == arrayItem.name
    //           );
    //           searchObject.status = "Failed";
    //         });
    //       }
    //     })
    //     .catch((error) => {
    //       const searchObject = this.filesArray.find(
    //         (search) => search.name == image.name
    //       );
    //       searchObject.status = "Failed";
    //     });
    // },

    onChangeEventHandler() {
      if (this.uploadType == "file") {
        this.uploadType = "folder";
      } else {
        this.uploadType = "file";
      }
    },

    selectFiles(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      for (let index = 0; index < files.length; index++){
        if(files[index].type!=''){
          this.files.push(files[index]);
        }
      }
      for (const file of this.files) {
          let temp = {};
          temp.name = file.name;
          temp.size = file.size;
          temp.type = file.type;

          temp.progress = "width: 0%";
          temp.status = "Pending";

          this.filesArray.push(temp);
      }
      this.counter++;
    },
    async multipartUpload() {
      const queue = this.files;

      for (let index = 0; index < queue.length; index++) {
        this.uploadSingleImage(queue[index]);
      }
    },

    uploadSingleImage(image) {
      const myUploadProgress = (myFileName) => (progress) => {
        let percentage = Math.floor((progress.loaded * 100) / progress.total);
        const searchObject = this.filesArray.find(
          (image) => image.name == myFileName
        );

        searchObject.progress = "width:" + percentage + "%";
      };

      let formData = new FormData();
      formData.append("file", image);
      if (this.imageType) {
        formData.append("type", this.imageType);
      }
      formData.append("batchId", this.batchId);
      var config = {
        onUploadProgress: myUploadProgress(image.name),
      };

      return semaphore.acquire().then((release) => {
        Http()
          .post(OCR_ENDPOINTS.images, formData, config)
          .then((response) => {
            let success = response?.data?.images;
            let fail = response?.data?.failedImages;
            if (success.length) {
              success.forEach((arrayItem) => {
                const searchObject = this.filesArray.find(
                  (search) => search.name == arrayItem.name
                );
                if(this.batch.numberOfImages==null){
                  this.batch.numberOfImages=0;
                }
                this.batch.numberOfImages++;
                searchObject.status = "Done";
              });
            }
            if (fail?.length) {
              fail.forEach((arrayItem) => {
                const searchObject = this.filesArray.find(
                  (image) => image.name == arrayItem.name
                );
                searchObject.status = "Failed";
              });
            }
          })
          .catch((error) => {
            const searchObject = this.filesArray.find(
              (search) => search.name == image.name
            );
            searchObject.status = "Failed";
          })
          .finally(() => {
            release();
          });
      });
    },
  },
};
</script>

<style scoped>
button {
  transition: all 0.3s;
}

button:hover {
  background-color: gray !important;
}

button:disabled {
  background-color: gray !important;
}

:focus {
  outline: none;
}

.col-3 {
  position: relative;
}

/* necessary to give position: relative to parent. */
input[type="text"],
input[type="password"],
input[type="file"] {
  font: 15px/24px "Lato", Arial, sans-serif;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
}

select {
  font: 15px/24px "Lato", Arial, sans-serif;
  color: #333;
  width: 100%;
  box-sizing: border-box;
  letter-spacing: 1px;
  padding: 7px 0 !important;
}

.effect-16 {
  border: 0;
  padding: 4px 0;
  border-bottom: 1px solid #ccc;
  background-color: transparent;
}

.effect-16 ~ .focus-border {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #3399ff;
  transition: 0.4s;
}

.effect-16:focus ~ .focus-border,
.has-content.effect-16 ~ .focus-border {
  width: 100%;
  transition: 0.4s;
}

.effect-16 ~ label {
  position: absolute;
  left: 0;
  width: 100%;
  top: 9px;
  color: #aaa;
  transition: 0.3s;
  z-index: -1;
  letter-spacing: 0.5px;
}

.effect-16:focus ~ label,
.has-content.effect-16 ~ label {
  top: -16px;
  font-size: 12px;
  color: #3399ff;
  transition: 0.3s;
}

select:required:invalid {
  color: gray;
}

option[value=""][disabled] {
  display: none;
}
</style>
